import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { KeyRound, MailCheck, ArrowLeft } from "lucide-react";

// Iter 136: recupero password — invia via email un link valido 30 minuti
export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const em = email.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) return setError("Inserisci un'email valida");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: em });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F6FB] flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-slate-200 p-8" data-testid="forgot-password-page">
        <Link to="/login" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-800" data-testid="forgot-back-link">
          <ArrowLeft className="h-4 w-4" /> Torna al login
        </Link>
        {sent ? (
          <div className="mt-6 text-center" data-testid="forgot-password-sent">
            <MailCheck className="h-12 w-12 mx-auto text-emerald-600" />
            <h1 className="mt-4 text-2xl font-heading font-bold">Controlla la tua email</h1>
            <p className="mt-3 text-sm text-slate-600">
              Se <b>{email.trim()}</b> è registrata, riceverai entro pochi minuti un link per scegliere una nuova password.
              Il link vale <b>30 minuti</b> e si può usare una sola volta.
            </p>
            <p className="mt-3 text-xs text-slate-500">Non arriva? Controlla la cartella spam oppure riprova.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} noValidate className="mt-6 space-y-5">
            <div className="flex items-center gap-3">
              <div className="h-11 w-11 rounded-xl bg-blue-50 text-[#0044FF] flex items-center justify-center">
                <KeyRound className="h-6 w-6" />
              </div>
              <div>
                <h1 className="text-2xl font-heading font-bold leading-tight">Password dimenticata?</h1>
                <p className="text-sm text-slate-500">Ti mandiamo un link per sceglierne una nuova.</p>
              </div>
            </div>
            <div className="space-y-2">
              <Label htmlFor="fp-email" className="text-sm font-bold">Email dell'account</Label>
              <Input
                id="fp-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="nome@azienda.it"
                autoComplete="email"
                className="h-14 text-base"
                data-testid="forgot-email-input"
              />
            </div>
            {error && (
              <div role="alert" data-testid="forgot-error" className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
                {error}
              </div>
            )}
            <Button type="submit" disabled={loading} data-testid="forgot-submit-button" className="w-full h-14 text-base font-bold bg-[#0044FF] hover:bg-[#0033CC]">
              {loading ? "Invio in corso…" : "Inviami il link"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
